<template>
    <div style="background-color: #fafafa;">
		<van-nav-bar title="订单列表" left-text="返回" right-text="下单" left-arrow @click-left="onClickLeft" @click-right="onClickRight" fixed></van-nav-bar>
		<div class="psiConfirmCont">
			<van-search class="search-box" shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch" @input="onSearch"
						@cancel="onSearch" @clear="onSearch">
				<div slot="action" @click="onSearch">搜索</div>
			</van-search>
			<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
				<van-list v-model="loading" :finished="finished" @load="onLoad" class="listBox" finished-text="没有更多了">
					<div style="width: 100%;" v-for="(item, index) in list" class="card" :key="item.uuid" @click="openDetail(item.uuid)">
						<table class="layout" style="width: 100%;" >
							<tr style="width: 100%;">
								<td style="width: 60%;">
									<div class="header">
										<span class="title">{{item.serialNumber}}</span>
									</div>
								</td>
								<td style="width: 40%;text-align: center;">
									<span v-if="item.orderStatus!='7abc7d71425740e58f849f8deb06c751' && !item.isMainChange && !item.isPartsChange" class="title">{{item.orderStatusname}}</span>
									<span v-if="item.orderStatus=='7abc7d71425740e58f849f8deb06c751' || item.isMainChange || item.isPartsChange" class="title" style="color: red;">{{item.orderStatusname}}</span>
								</td>
							</tr>
							<tr style="width: 100%;">
								<td colspan="2" class="content" style="width: 100%;">
									<p><span>经销商：</span><span>{{item.dealerName}}</span></p>
									<p><span>暖气结算金额：</span><span>{{item.mainSettleAmount}}</span></p>
									<p><span>配件结算金额：</span><span>{{item.partsSettleAmount}}</span></p>
									<p><span>客户姓名：</span><span>{{item.customerId}}</span></p>
									<p><span>客户手机：</span><span>{{item.customerMobile}}</span></p>
									<p style="width: 100%;"><span>客户地址：</span><span>{{item.customerAddress}}</span></p>
									<p style="width: 100%;"><span>备注：</span><span>{{item.remark}}</span></p>
								</td>
							</tr>
						</table>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
    </div>
</template>

<script>
    import {Tab, Tabs, Panel, Button, List, Search, Popup,PullRefresh,NavBar} from 'vant';
	import dealerOrderService from "../../service/dealerOrderService";
    import {formatDictionary} from "../../utils/dictionary";
	import {formatMoney} from "../../utils/money";
	import moment from "moment";
    export default {
        data: function () {
            return {
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                refreshing: false,
				value: ''
            }
        },
      
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [PullRefresh.name]: PullRefresh,
            [Panel.name]: Panel,
            [List.name]: List,
            [Search.name]: Search,
            [Popup.name]: Popup,
			[NavBar.name]: NavBar,
        },
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await dealerOrderService.getDealerOrderList(this.pageIndex, this.value);
                resp.data.Data.data.forEach(item => {
                    item.createTime = moment(item.createTime).format('YYYY-MM-DD');
                    if(item.customerAddress && item.customerAddress.length > 22){
                    	let temp = item.customerAddress;
						item.customerAddress = temp.substring(0, 22);
						item.customerAddress += "...";
					}
					if(item.remark && item.remark.length > 22){
						let temp = item.remark;
						item.remark = temp.substring(0, 22);
						item.remark += "...";
					}
					item.mainSettleAmount = formatMoney(item.mainSettleAmount || "0.00");
					item.partsSettleAmount = formatMoney(item.partsSettleAmount || "0.00");
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onRefresh() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
			onSearch() {
				this.finished = false;
				this.loading = true;
				this.pageIndex = 0;
				this.list = [];
				this.onLoad();
			},
			async openDetail(orderId){
				this.$router.push({path:"/app/forms/bd47b33ddd334e93a6c17782b51c5f89/"+orderId});
            },
			onClickLeft(){
				window.open('/colseWebView');
			},
			onClickRight(){
				this.$router.push({path:"orderSku",  query:{type: "0"}} );
			},
        }
    };

</script>
<style>
	.card p {
		margin:10px 0;
	}
	.card p>span:first-child {
		flex: 0 0 4rem;
		text-align: right;
		margin-right: 20px;
	}
	.van-pull-refresh__head{
		display: none;
	}
	.recordBox {
		padding: 0.5rem 0;
		box-sizing: border-box;
		margin-top: 2rem;
		bottom:0;
		position:fixed;
		width: 100%;
	}
	.psiConfirmCont{
		width:100%;
		margin:0 auto;
		margin-top:100px;
		overflow: hidden;

	}
</style>